export default {
  nickname: 'ニックネーム',
  last_name: '姓',
  first_name: '名',
  last_name_kana: '姓(ふりがな)',
  first_name_kana: '名(ふりがな)',
  birthday: '生年月日',
  birthtime: '出生時間',
  from_pref: '出生地',
  birthorder: '出生順',
  gender: '性別',
  job: '職業',
  relationship: '恋愛状況',
  blood: '血液型',
  target_nickname: '相手のニックネーム',
  target_last_name: '相手の姓',
  target_first_name: '相手の名',
  target_last_name_kana: '相手の姓(ふりがな)',
  target_first_name_kana: '相手の名(ふりがな)',
  target_birthday: '相手の生年月日',
  target_birthtime: '相手の出生時間',
  target_from_pref: '相手の出生地',
  target_birthorder: '相手の出生順',
  target_gender: '相手の性別',
  target_job: '相手の職業',
  target_blood: '相手の血液型',
  picture1_url: '写真(顔相)',
  picture2_url: '写真(手相)',
  picture3_url: '写真(風水)',
  image_url_palm_left_overall: '左手の手相(全体)',
  image_url_palm_left: '左手の手相(拡大)',
  image_url_palm_right_overall: '右手の手相(全体)',
  image_url_palm_right: '右手の手相(拡大)',
  image_url_palm_left_overall_short: '全体',
  image_url_palm_left_short: '拡大',
  image_url_palm_right_overall_short: '全体',
  image_url_palm_right_short: '拡大',

  email: 'メールアドレス',
  email_conf: 'メールアドレス',
  new_email: 'メールアドレス',
  new_email_confirm: 'メールアドレス',
  password: 'パスワード',
  re_password: 'パスワード',
  love_status: '恋人の有無',
  connection_period: '関係性の期間',
  romance_history: '過去にお付き合いした人数',
  lover_search_period: '恋人がいない期間',
  entry_genre: '相談したいテーマ',
  entry_detail: '一番聞きたいこと',
  praise_detail: '占ってほしいこと',
  has_partner: '恋人の有無',
  metal_name: 'メタルネーム（動画の中でお呼びするお名前です）',
  neko_name: '名前　※自分以外も占えます',
  neko_theme: '相談したいテーマ',
  licorice_name: 'ニックネーム'
};



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/FORM_LABELS.js